import { createSelector } from "reselect";
const selfState = (state) => state;

export const globalFilterSelector = createSelector(selfState, (state) => state.globalFilter);
